// extracted by mini-css-extract-plugin
export default {"subtitle":"login-page_subtitle__ca2WU","form":"login-page_form__WCPjc","error":"login-page_error__EidoV","forgotten":"login-page_forgotten__YS2Ig"};